const impactSectionList =
[
  {
    key:['Q203'],
    // The Global Compact recognizes that implementing universal principles into business strategy, culture and operations can be a long-term process and encourages participants to follow a path of continuous improvement.
    description: "Overall, how would you describe your company’s current level of implementation of the Global Compact’s ten principles?",
    dropDownQuestion: "Company's level of implementation of the ten principles",
    optionMap: {
      '1': '1 - Beginner',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5 - Advanced performer',

    }
  },
  {
    key:['Q220'],
    description: "Overall, to what extent has participation in the Global Compact helped advance corporate responsibility policies and/or practices within your company?",
    dropDownQuestion: "How UN Global Compact participation has helped advance corporate sustainability within the company",
    optionMap: {
      '1': 'No impact',
      '2': 'Minimally helped advance efforts',
      '3': 'Moderately helped advance efforts',
      '4': 'Significantly helped advance efforts',
      '5': 'Advancement would not have happened without being a participant'
    }
  },
  {
    key:['Q106'],
    description: "In your view, how significant has the Global Compact been in spreading the practice of corporate sustainability worldwide?",
    dropDownQuestion: "Perceived significance of the UN Global Compact's role worldwide",
    optionMap: {
      '1': 'No impact',
      '2': 'Minimal',
      '3': 'Moderate',
      '4': 'Significant',
      '5': 'Essential'
    }
  },
  {
    key:['Q105_1'],
    description: "To what extent do you agree with the following statements: 'The Global Compact has played an important role in shaping our company's vision",
    dropDownQuestion: "What companies are saying: in shaping our vision",
    optionMap: {
      '1': '1 - Strongly disagree',
      '2': '2 - Disagree',
      '3': '3 - Neither agree of disagree',
      '4': '4 - Agree',
      '5': '5 - Strongly agree'
    }
  },
  {
    key:['Q105_2'],
    description: "To what extent do you agree with the following statements: 'The Global Compact has played an important role in driving our implementation of sustainability policies and practices",
    dropDownQuestion: "What companies are saying: in driving our implementation of sustainability policies and practices",
    optionMap: {
      '1': '1 - Strongly disagree',
      '2': '2 - Disagree',
      '3': '3 - Neither agree of disagree',
      '4': '4 - Agree',
      '5': '5 - Strongly agree'
    }
  },
  {
    key:['Q105_3'],
    description: "To what extent do you agree with the following statements: 'The Global Compact has played an important role in guiding our corporate sustainability reporting",
    dropDownQuestion: "What companies are saying: in guiding our corporate sustainability reporting",
    optionMap: {
      '1': '1 - Strongly disagree',
      '2': '2 - Disagree',
      '3': '3 - Neither agree of disagree',
      '4': '4 - Agree',
      '5': '5 - Strongly agree'
    }
  },
  {
    key:['Q105_4'],
    description: "To what extent do you agree with the following statements: 'The Global Compact has played an important role in motivating our company to advance broader UN goals and issues, such as the Sustainable Development Goals",
    dropDownQuestion: "What companies are saying: in motivating our company to advance the Sustainable Development Goals",
    optionMap: {
      '1': '1 - Strongly disagree',
      '2': '2 - Disagree',
      '3': '3 - Neither agree of disagree',
      '4': '4 - Agree',
      '5': '5 - Strongly agree'
    }
  },
  {
    key:['Q143_1'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Increase trust in company through public commitment to sustainability",
    dropDownQuestion: "Participating in the UN Global Compact to increases trust in company through public commitment to sustainability",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_2'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Address humanitarian concerns",
    dropDownQuestion: "Participating in the UN Global Compact addresses humanitarian concerns",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_3'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Global Compact is a global initiative with local presence",
    dropDownQuestion: "Participating in the UN Global Compact provides a global initiative with local presence",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_4'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Acquire knowledge to advance sustainability into operations and strategy",
    dropDownQuestion: "Participating in the UN Global Compact helps advance sustainability into operations and strategy",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_5'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Establish links with UN",
    dropDownQuestion: "Participating in the UN Global Compact establishes links with UN",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_6'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Networking with other organizations",
    dropDownQuestion: "Participating in the UN Global Compact allows networking with other organizations",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_7'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Universal nature of the principles",
    dropDownQuestion: "Participating in the UN Global Compact connects organization with universal nature of the principles",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_8'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Address business opportunities and risks",
    dropDownQuestion: "Participating in the UN Global Compact addresses business opportunities and risks",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_9'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Comprehensive framework that includes the range of sustainability issues",
    dropDownQuestion: "Participating in the UN Global Compact provides comprehensive framework on sustainability issues",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_10'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Promotes action on sustainability within the company",
    dropDownQuestion: "Participating in the UN Global Compact promotes action on sustainability within the company",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_11'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Attract, motivate and retain employees",
    dropDownQuestion: "Participating in the UN Global Compact allows company to attract, motivate and retain employees",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_12'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Pressure from external stakeholders",
    dropDownQuestion: "Participating in the UN Global Compact is due to pressure from external stakeholders",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_13'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Investor efforts to evaluate corporate sustainability performance",
    dropDownQuestion: "Participating in the UN Global Compact allows investors to evaluate corporate sustainability performance",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_14'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Other",
    dropDownQuestion: "Participating in the UN Global Compact is for other reasons",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
  {
    key:['Q143_15'],
    description: "Reasons for your company’s participation in the Global Compact? scale 1 to 5 - Unsure",
    dropDownQuestion: "Participating in the UN Global Compact: Unsure",
    optionMap: {
      '1': 'Essential',
      '2': 'Significant',
      '3': 'Moderate',
      '4': 'Minimal',
      '5': 'No impact',

    }
  },
]

export {impactSectionList};



// WEBPACK FOOTER //
// ./src/App/data/impactSectionList.js